<script setup lang="ts">
/**
 * Master Layout - ScholarTrip 2.0
 * 解決方案：
 * 1. 使用 Page Meta 驅動 Header 狀態 (不再寫死路徑)
 * 2. 整合全域 Teleport 掛載點
 * 3. 處理 Mobile 捲動彈性與 Safe Area
 */
import { useWindowScroll } from "@vueuse/core";
const route = useRoute();
const { y } = useWindowScroll();
// 💡 解決方案：反轉控制，讓頁面自定義 transparentHeader: true
const isTransparentRequested = computed(() => {
  return route.meta.transparentHeader === true || route.path === "/";
});
const isScrolled = computed(() => y.value > 60);
</script>
<template>
  <div class="min-h-dvh flex flex-col font-sans bg-slate-50 antialiased">
    <!-- 統一導覽列：自動切換 Glass / Transparent 模式 -->
    <LayoutTheHeader
      :is-transparent="isTransparentRequested && !isScrolled"
      :is-scrolled="isScrolled"
    />
    <!-- 主內容區 -->
    <main class="flex-grow">
      <NuxtPage />
    </main>
    <LayoutTheFooter />
    <!-- 全域交互組件掛載 -->
    <AuthStudentVerificationModal />
    <SupportOmnichannelConcierge />
  </div>
</template>
<style>
/* 補齊全域基礎樣式細節 */
html {
  scroll-behavior: smooth;
  -webkit-text-size-adjust: 100%;
}
/* 優化捲軸質感 */
::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}
::-webkit-scrollbar-thumb {
  @apply bg-slate-300 rounded-full
hover:bg-brand-500;
}
::-webkit-scrollbar-track {
  @apply bg-transparent;
}
</style>
